import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import * as bulmaToast from "bulma-toast";
import { useTranslation } from "react-i18next";

export default function Contact() {
  const initialValues = { user_name: "", user_email: "", message: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setErrors(validate(formValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    //console.log(errors);
    if (Object.keys(errors).length === 0 && isSubmit) {
      emailjs
        .sendForm(
          "service_js9rkwc",
          "template_itar6gu",
          form.current,
          "Op7pqeeiX8-JvYpCS"
        )
        .then(
          (result) => {
            bulmaToast.toast({
              message: "Message sent successfully",
              type: "is-primary",
              position: "center",
              closeOnClick: true,
              dismissible: true,
              pauseOnHover: true,
            });
            console.log(result);
          },
          (error) => {
            bulmaToast.toast({
              message: "Message was not sent",
              type: "is-danger",
              position: "center",
              closeOnClick: true,
              dismissible: true,
              pauseOnHover: true,
            });
            console.log(error.text);
          }
        );
      //console.log(formValues);
      setFormValues(initialValues);
    }
    // eslint-disable-next-line
  }, [errors]);
  // eslint-disable-next-line
  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.user_email) {
      errors.user_email = "Email is required!";
    } else if (!regex.test(values.user_email)) {
      errors.user_email = "This is not a valid email format!";
    }
    if (!values.message) {
      errors.message = "Message is required!";
    }
    if (!values.user_name) {
      errors.user_name = "Name is required!";
    } else if (values.user_name.length < 3) {
      errors.user_name = "Name not valid!";
    }

    return errors;
  };
  const { t } = useTranslation();

  return (
    <section className="section" data-aos="zoom-in">
      <div id="contact" className="section is-medium">
        <div className="content ">
          <h1 className="block is-size-1 has-text-centered underline">
            <span>Contact</span>
          </h1>
        </div>
        <div className="columns ">
          <div className="column is-8 is-offset-2 ">
            <div className="box cardDark">
              <div className="content">
                <h6 className="block subtitle is-6 has-text-weight-bold is-hidden-mobile">
                  {t("contact.msg")}
                </h6>
              </div>
              <form ref={form} onSubmit={sendEmail}>
                <p>{errors.user_name}</p>
                <input
                  className={`input is-medium  block ${
                    errors.user_name ? "is-danger" : "is-success"
                  }  `}
                  type="text"
                  placeholder={t("contact.form.name")}
                  name="user_name"
                  onChange={handleChange}
                  value={formValues.user_name}
                ></input>
                <p>{errors.user_email}</p>
                <input
                  className={`input is-medium block ${
                    errors.user_email ? "is-danger" : "is-success"
                  }  `}
                  type="text"
                  placeholder="Email"
                  name="user_email"
                  onChange={handleChange}
                  value={formValues.user_email}
                ></input>
                <p>{errors.message}</p>
                <textarea
                  name="message"
                  className={`textarea is-medium is-large block ${
                    errors.message ? "is-danger" : "is-success"
                  }`}
                  rows="7"
                  onChange={handleChange}
                  value={formValues.message}
                  placeholder={t("contact.form.msg")}
                ></textarea>

                <div className="buttons is-right">
                  <button
                    className="button is-medium is-primary is-rounded is-right"
                    type="submit"
                  >
                    {t("btns.send")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="columns is-mobile is-centered ">
        <div className="column  has-text-centered  is-half ">
          <div className="content">
            <h3 className="block is-3 footerContent">{t("contact.find")}</h3>
            <h6 className="subtitle is-6 has-text-grey">{t("contact.me")}</h6>
          </div>
          <a
            href="https://www.linkedin.com/in/montassar-khefifi-251b25179/"
            target="_black"
          >
            <i className="devicon-linkedin-plain socialMediaIcon"></i>
          </a>
          <a href="https://github.com/Montassar1999" target="_black">
            <i className="devicon-github-original socialMediaIcon"></i>
          </a>
          <a href="https://twitter.com/MontassarKhefif" target="_black">
            <i className="devicon-twitter-original socialMediaIcon"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
